export default __webpack_public_path__ + "static/media/nbf.1dc1b225.jpg";